module.exports = {
  list: [
    "Banco do Brasil",
    "Bradesco",
    "Caixa Econômica Federal",
    "City Bank",
    "Itaú",
    "Santander"
  ]
};
